import React from 'react';
import SbEditable from 'storyblok-react';

import Components from '../components';
import './full-width-content-block.scss';

const FullWidthContentBlock = (props) => {
  const classes = ['full-width-content-block'];
  const styles = {};

  if (props.blok.background_image.id) {
    styles['backgroundImage'] = 'url("' + props.blok.background_image.filename + '")';
  }

  if (props.blok.background_color && props.blok.background_color.color !== '#f40000') {
    styles['backgroundColor'] = props.blok.background_color.color;
  }

  if (props.blok.text_align) {
    classes.push('text-align-' + props.blok.text_align);
  }

  classes.push('height-' + props.blok.height);

  const contentClasses = ['full-width-content'];

  if (props.blok.size_extended) {
    contentClasses.push('size-extended');
  }

  if (props.blok.content_halign) {
    contentClasses.push('h-align-' + props.blok.content_halign);
  }

  return (
    <SbEditable content={props.blok}>
      <section className={classes.join(' ')} style={styles}>
        <div className={contentClasses.join(' ')}>
          {props.blok.items.map((blok) =>
            React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
          )}
        </div>
      </section>
    </SbEditable>
  );
};

export default FullWidthContentBlock;
